<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div id="pageItemList">
    <page-header></page-header>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                flat
                solo
                prepend-icon="search"
                :placeholder="$t('fulltextSearch')"
                v-model="searchInput"
                hide-details
                class="hidden-sm-and-down"
              ></v-text-field>
              <v-menu
                :close-on-content-click="false"
                v-model="datePickers.fromMenuShow"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  prepend-icon="date_range"
                  label="od"
                  :value="
                    filter['occurrenceDate:from']
                      ? $moment(filter['occurrenceDate:from']).format('LL')
                      : null
                  "
                  readonly
                  clearable
                  @click:clear="filter['occurrenceDate:from'] = null"
                ></v-text-field>
                <v-date-picker
                  v-model="filter['occurrenceDate:from']"
                  @input="datePickers.fromMenuShow = false"
                  :locale="LANG"
                ></v-date-picker>
              </v-menu>
              <v-menu
                :close-on-content-click="false"
                v-model="datePickers.toMenuShow"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  label="do"
                  :value="
                    filter['occurrenceDate:to']
                      ? $moment(filter['occurrenceDate:to']).format('LL')
                      : null
                  "
                  readonly
                  clearable
                  @click:clear="filter['occurrenceDate:to'] = null"
                ></v-text-field>
                <v-date-picker
                  v-model="filter['occurrenceDate:to']"
                  @input="datePickers.toMenuShow = false"
                  :locale="LANG"
                ></v-date-picker>
              </v-menu>

              <v-menu>
                <v-btn icon slot="activator">
                  <v-icon>turned_in_not</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile
                    @click="filter.status = null"
                    :class="filter.status === null ? 'primary--text' : ''"
                  >
                    <v-list-tile-title class="font-italic">{{
                      $t("all")
                    }}</v-list-tile-title>
                  </v-list-tile>
                  <v-divider></v-divider>
                  <v-list-tile
                    @click="filter.status = 'NEW'"
                    :class="filter.status === 'NEW' ? 'primary--text' : ''"
                  >
                    <v-list-tile-title class="font-italic">{{
                      $t("new")
                    }}</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    @click="filter.status = 'active'"
                    :class="filter.status === 'active' ? 'primary--text' : ''"
                  >
                    <v-list-tile-title class="font-italic">{{
                      $t("active")
                    }}</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    @click="filter.status = 'resolved'"
                    :class="filter.status === 'resolved' ? 'primary--text' : ''"
                  >
                    <v-list-tile-title class="font-italic">{{
                      $t("resolved")
                    }}</v-list-tile-title>
                  </v-list-tile>
                  <v-divider></v-divider>
                  <v-list-tile
                    v-for="(item, index) in getAllIssuesList"
                    :key="index"
                    @click="filter.status = item.value"
                    :class="filter.status === item.value ? 'primary--text' : ''"
                  >
                    <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="headers"
                :items="issues"
                :rows-per-page-items="[10, 25, 50]"
                :pagination.sync="pagination"
                :total-items="issuesCount"
                :loading="issueIsLoading"
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.rma }}</td>
                  <td>
                    <au-vehicle :vehicle="props.item.vehicle" />
                  </td>
                  <td>{{ props.item.item | truncate }}</td>
                  <td>{{ props.item.occurrence_date | moment("LL") }}</td>
                  <td>
                    <v-edit-dialog
                      v-if="
                        isStatusEditable(props.item) &&
                          hasPermission(ROLE_PERMISSION_ISSUE_CHANGE_STATUS)
                      "
                      :return-value.sync="newStatus"
                      lazy
                      large
                      @save="updateStatusAction(props.item)"
                      @open="newStatus = props.item.status"
                      :cancel-text="$t('cancel')"
                      :save-text="$t('updateStatus')"
                    >
                      <v-icon>turned_in_not</v-icon>
                      <span class="text-no-wrap">{{
                        $t("issueStatus." + props.item.status)
                      }}</span>
                      <v-select
                        slot="input"
                        v-model="newStatus"
                        :items="getAllIssuesList"
                      ></v-select>
                    </v-edit-dialog>
                    <span v-else>
                      {{ $t("issueStatus." + props.item.status) }}
                    </span>
                  </td>
                  <td>{{ props.item.created_at | moment("LLL") }}</td>
                  <td>
                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                          <v-icon>more_vert</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-tile
                          v-if="
                            hasPermission(
                              ROLE_PERMISSION_SERVICE_REPORT_CREATE
                            ) &&
                              props.item.status !== 'RESOLVED' &&
                              props.item.status !== 'UNCONFIRMED'
                          "
                          :to="{
                            name: 'ServiceReportCreateWithIssue',
                            params: { issueId: props.item.id }
                          }"
                        >
                          <v-list-tile-action>
                            <v-icon color="teal darken-2">build</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-title>
                            {{ $t("createServiceReport") }}
                          </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile
                          v-if="
                            hasPermission(ROLE_PERMISSION_ISSUE_FINNISH) &&
                              props.item.status !== 'RESOLVED' &&
                              props.item.status !== 'UNCONFIRMED'
                          "
                          @click="finnishIssueAction(props.item.id)"
                        >
                          <v-list-tile-action>
                            <v-icon color="grey darken-2">flag</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-title>
                            {{ $t("finnishIssue") }}
                          </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile
                          :to="{
                            name: 'IssueShow',
                            params: { id: props.item.id }
                          }"
                        >
                          <v-list-tile-action>
                            <v-icon color="primary">details</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-title>
                            {{ $t("details") }}
                          </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile
                          v-if="canEdit(props.item)"
                          @click="editAction(props.item.id)"
                        >
                          <v-list-tile-action>
                            <v-icon color="info">edit</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-title>
                            {{ $t("edit") }}
                          </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile
                          v-if="canEdit(props.item)"
                          @click="$refs.deleteDialog.deleteAction(props.item)"
                        >
                          <v-list-tile-action>
                            <v-icon color="red">delete</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-title>
                            {{ $t("delete") }}
                          </v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <issues-create-edit-dialog
      v-model="modal"
      @saved="fetchItems"
    ></issues-create-edit-dialog>

    <issue-finnish-dialog
      v-model="finnishModal"
      @saved="fetchItems"
    ></issue-finnish-dialog>

    <delete-dialog
      messageKey="deleteIssueMessage"
      itemKey="rma"
      ref="deleteDialog"
      @confirm="deleteConfirmation"
    ></delete-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  FETCH_ISSUES,
  FETCH_ISSUE,
  DELETE_ISSUE,
  SHOW_SNACKBAR,
  UPDATE_ISSUE_STATUS
} from "@/store/actions.type";
import refreshButtonMixin from "@/mixins/refreshButton.mixin";
import createButtonMixin from "@/mixins/createButton.mixin";
import searchInputMixin from "@/mixins/searchInput.mixin";
import paginationMixin from "@/mixins/pagination.mixin";
import IssuesCreateEditDialog from "@/views/Issue/IssuesCreateEditDialog.vue";
import IssueFinnishDialog from "@/views/Issue/IssueFinnishDialog.vue";
import IssueStates from "@/common/enums/issueStatus.service";
import {
  ROLE_PERMISSION_ISSUE_CHANGE_STATUS,
  ROLE_PERMISSION_SERVICE_REPORT_CREATE,
  ROLE_SUPER_ADMIN,
  ROLE_PERMISSION_ISSUE_FINNISH
} from "@/common/permissions";
import { NEW } from "@/common/enums/issueStatuses";
import {
  FETCH_SERVICE_REPORTS_FOR_ISSUE,
  RESET_ISSUE
} from "@/store/actions.type";
import _ from "lodash";

export default {
  components: {
    "issues-create-edit-dialog": IssuesCreateEditDialog,
    "issue-finnish-dialog": IssueFinnishDialog
  },
  data() {
    return {
      modal: {
        show: false,
        mode: ""
      },
      finnishModal: {
        show: false,
        issueId: null
      },
      filter: {
        "occurrenceDate:from": null,
        "occurrenceDate:to": null,
        status: null
      },
      datePickers: {
        fromMenuShow: false,
        toMenuShow: false
      },
      LANG: process.env.VUE_APP_LANG,
      ROLE_PERMISSION_ISSUE_CHANGE_STATUS: ROLE_PERMISSION_ISSUE_CHANGE_STATUS,
      ROLE_PERMISSION_SERVICE_REPORT_CREATE: ROLE_PERMISSION_SERVICE_REPORT_CREATE,
      ROLE_PERMISSION_ISSUE_FINNISH: ROLE_PERMISSION_ISSUE_FINNISH,
      headers: [
        { text: this.$t("number"), value: "rma" },
        { text: this.$t("vehicle"), value: "vehicle" },
        { text: this.$t("issueItem"), value: "item" },
        { text: this.$t("occurrenceDate"), value: "occurrenceDate" },
        { text: this.$t("status"), value: "status" },
        { text: this.$t("creationDate"), value: "created_at" },
        { text: this.$t("actions"), sortable: false }
      ],
      newStatus: ""
    };
  },
  computed: {
    ...mapGetters([
      "issues",
      "issuesCount",
      "issue",
      "issueIsLoading",
      "currentUser",
      "hasPermission",
      "finnishIssue",
      "serviceReports"
    ]),
    getAllIssuesList() {
      return IssueStates.getAll();
    }
  },
  watch: {
    filter: {
      handler: function() {
        this.fetchItems();
      },
      deep: true
    }
  },
  mixins: [
    refreshButtonMixin,
    createButtonMixin,
    searchInputMixin,
    paginationMixin
  ],
  methods: {
    fetchItems() {
      this.$store.dispatch(FETCH_ISSUES, [
        this.pagination,
        this.search,
        this.filter
      ]);
    },
    createAction() {
      this.$store.dispatch(RESET_ISSUE);
      this.modal.mode = "create";
      this.modal.show = true;
    },
    editAction(id) {
      this.$store.dispatch(FETCH_ISSUE, id).then(() => {
        this.modal.mode = "edit";
        this.modal.show = true;
      });
    },
    finnishIssueAction(id) {
      this.$store.dispatch(FETCH_SERVICE_REPORTS_FOR_ISSUE, id).then(() => {
        this.finnishIssue.service_reports = _.compact(
          this.serviceReports.map(serviceReport => {
            return serviceReport.issue ? serviceReport.id : null;
          })
        );
        this.finnishModal.issueId = id;
        this.finnishModal.show = true;
      });
    },
    deleteConfirmation(issue) {
      this.$store.dispatch(DELETE_ISSUE, issue.id).then(() => {
        this.$store.dispatch(SHOW_SNACKBAR, {
          text: this.$t("deletedSuccessfully", [this.$t("issue")]),
          color: "success"
        });

        this.fetchItems();
      });
    },
    canEdit(issue) {
      return (
        (issue.created_by &&
          issue.created_by.id === this.currentUser.id &&
          issue.status === NEW) ||
        this.hasPermission(ROLE_SUPER_ADMIN)
      );
    },
    isStatusEditable(issue) {
      return IssueStates.isEditable(issue.status);
    },
    updateStatusAction(item) {
      this.$store
        .dispatch(UPDATE_ISSUE_STATUS, {
          id: item.id,
          status: this.newStatus
        })
        .then(() => {
          item.status = this.newStatus;
          this.$store.dispatch(SHOW_SNACKBAR, {
            text: this.$t("statusUpdatedSuccessfully"),
            color: "success"
          });
        });
    }
  }
};
</script>

<style scoped></style>
